import CheckoutModal from "./checkout_modal/index"
import MobileWarning from "./mobile_warning/index"
import ProUpgradeModal from "./pro_upgrade/index"
import modalCopy from "./modal_copy"

interface URLs {
  modalSubscriptionUrl: string
  newProSubscriptionUrl: string
  newProPlusSubscriptionUrl: string
}
interface User {
  eligibleForTrial: boolean
  isTrialing: boolean
  subscriptionPaymentType: string
  tier: string
}
interface Props {
  appletFeatureFlags: {
    intermediate_pro_features: boolean
    pro_features: boolean
  }
  onClose: () => void
  onUpgrade: () => void
  premiumService: string
  proPlusProductId: string
  step: string
  tierRequirement: string
  trackLocationType: string
  urls: URLs
  user: User
  visible: boolean
}

const UpgradePlanModal = (props: Props) => {
  const {
    appletFeatureFlags,
    onClose,
    premiumService,
    proPlusProductId,
    step,
    tierRequirement,
    trackLocationType,
    user,
    visible,
  } = props
  const canUpgrade = user.subscriptionPaymentType === "stripe"
  const upgradingExistingSubscription = user.tier !== "free"
  const modalCopyObj = modalCopy({
    appletFeatureFlags,
    currentTier: user.tier,
    eligibleForTrial: user.eligibleForTrial,
    isTrialing: user.isTrialing,
    premiumService,
    step,
    tierRequirement,
  })

  return upgradingExistingSubscription ? (
    canUpgrade ? (
      <ProUpgradeModal
        onClose={onClose}
        onUpgrade={props.onUpgrade}
        proPlusProductId={proPlusProductId}
        step={step}
        trackLocationType={trackLocationType}
        user={user}
        visible={visible}
        modalCopyObj={modalCopyObj}
      />
    ) : (
      <MobileWarning onClose={onClose} step={step} trackLocationType={trackLocationType} visible={visible} />
    )
  ) : (
    <CheckoutModal {...props} modalCopyObj={modalCopyObj} />
  )
}

export default UpgradePlanModal
